/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import {Highlights} from "../components/Highlights";
import {PeopleGrid} from "../components/PeopleGrid";
import {Gap} from "../components/Gap";
import {Layout as PageLayout} from "../components/Layout";
import {GroupPictures} from "../components/GroupPictures";
import {Contact} from "../components/Contact";
import {TextHeader} from "../components/TextHeader";
import {TitleHeader} from "../components/TitleHeader";
import {Sponsors} from "../components/Sponsors";
const MDXLayout = function Layout({children}) {
  return React.createElement(PageLayout, {
    lang: "en"
  }, children);
};
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(TitleHeader, {
    title: "Student Law Office Maastricht"
  }), "\n", React.createElement(Gap, {
    size: 50
  }), "\n", React.createElement(Highlights, {
    lang: "en"
  }), "\n", React.createElement(Gap, {
    size: 40
  }), "\n", React.createElement(TextHeader, {
    title: "Our Goal"
  }), "\n", React.createElement(_components.p, null, "The Maastricht Student Law Office has been providing free legal advice to students since the 1990s. This is made possible by 15-20 enthusiastic university law students who volunteer for the Law Office alongside their studies. The Maastricht Student Law Office is part of the"), "\n", React.createElement(_components.p, null, React.createElement(_components.a, {
    href: "https://www.lsr.nl/"
  }, "National Legal Aid Foundation")), "\n", React.createElement(_components.p, null, "We give advice by telephone, but you are also welcome during our walk-in consultation hours. You can also reach us by email. Whenever possible, we will try to advise you straight away, or we will refer you to a specialized body or lawyer if necessary."), "\n", React.createElement(_components.p, null, "The Legal Office mainly focuses on answering questions about tenancy law, education law, employment law and consumer law. Because our employees are broadly trained, you can of course also contact us with other types of legal problems. We do not assist students in the field of criminal law or matters with a major financial interest. Clients can also count on the confidentiality of what is discussed."), "\n", React.createElement(Gap, {
    size: 40
  }), "\n", React.createElement(TextHeader, {
    title: "Our Team"
  }), "\n", React.createElement(_components.p, null, "The Law Office consists of the following law students who volunteer alongside their studies to help students with legal problems."), "\n", React.createElement(PeopleGrid, {
    lang: "en"
  }), "\n", React.createElement(GroupPictures), "\n", React.createElement(Gap, {
    size: 40
  }), "\n", React.createElement(TextHeader, {
    title: "Contact"
  }), "\n", React.createElement(Contact, {
    lang: "en"
  }), "\n", React.createElement(Gap, {
    size: 40
  }), "\n", React.createElement(TextHeader, {
    title: "Sponsors"
  }), "\n", React.createElement(Sponsors, {
    lang: "en"
  }));
}
function MDXContent(props = {}) {
  return React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props));
}
export default MDXContent;
